export const tokens = {
  bg:        "#0a0a0a",
  surface:   "#141414",
  border:    "#1f1f1f",
  accent:    "#d4af37",
  accentDim: "#a98c2c",
  textHi:    "#e8e8e8",
  textMed:   "#888888",
  textLow:   "#666666",
  success:   "#10b981",
  warn:      "#f59e0b",
  error:     "#ef4444",
  fontHead:  '"Cormorant Garamond", "Times New Roman", serif',
  fontBody:  '"Inter", system-ui, sans-serif',
  fontMono:  '"JetBrains Mono", Consolas, monospace',
} as const;

export type DesignTokens = typeof tokens;
